import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { CrowdfundingService } from 'src/app/modules/crowdfunding/services/crowdfunding.service';
import { PlatformService } from 'src/app/modules/platform/services/platform.service';
import { SuccessChangePasswordDialog } from '../../../profile/pages/change-password/components/dialog-success-change-password/dialog-success-change-password.component';
import { DashboardService } from '../../service/dashboard.service';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-dialog-cashout',
  templateUrl: './dialog-cashout.component.html',
  styleUrls: ['./dialog-cashout.component.scss'],
})
export class DialogCashoutComponent implements OnInit {
  #unsubscribe = new Subject<void>();
  listCbu: any;
  listFilterCbu: any[] = [];
  cashOutForm: FormGroup;
  error: string | undefined;
  fxAndFeed: any;
  balance: any;
  withdrawSuccess: boolean = false;

  constructor(
    private platformService: PlatformService,
    private crowdfundingService: CrowdfundingService,
    private fb: FormBuilder,
    private _snackBar: MatSnackBar,
    private router: Router,
    private dialogRef: MatDialogRef<DialogCashoutComponent>,
    private dialog: MatDialog,
    private dashboardService: DashboardService
  ) {
    this.cashOutForm = this.fb.group({
      cbu: new FormControl('', [Validators.required]),
      currency: new FormControl('', [Validators.required]),
      money: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.getCbus();
    this.getFxAndFeed();
    this.getBalance();
  }

  get f() {
    return this.cashOutForm.controls;
  }

  getBalance() {
    this.dashboardService.getBalance().pipe(takeUntil(this.#unsubscribe)).subscribe({
      next: (result) => {
        this.balance = result;
        console.log(result);
      },
    });
  }

  getFxAndFeed() {
    this.crowdfundingService.getFxAndFees().pipe(takeUntil(this.#unsubscribe)).subscribe({
      next: (result) => {
        this.fxAndFeed = result;
      },
      error: (err) => {
        this._snackBar.open(err.error.error, '', {
          duration: 3000,
        });
      },
    });
  }

  setCurrency() {
    this.listFilterCbu = this.listCbu.filter((x: { currency: any }) => {
      return x.currency == this.cashOutForm.get('currency')?.value;
    });
  }

  getCbus() {
    this.platformService.getCBU().pipe(takeUntil(this.#unsubscribe)).subscribe({
      next: (result) => {
        this.listCbu = result.list;
        console.log(this.listCbu)
      },
      error: () => { },
    });
  }

  parseInt(value: string) {
    return parseInt(value);
  }

  getCommision() {
    const money = this.cashOutForm.value.money;
    const commision = money * this.fxAndFeed.fees.withdraw;

    return commision;
  }

  getTotal() {
    const money = this.cashOutForm.value.money;
    const commision = money * this.fxAndFeed.fees.withdraw;

    return money - commision;
  }

  withdrawMoney() {
    const data = {
      cbuId: this.cashOutForm.value.cbu,
      amount: parseInt(this.cashOutForm.value.money),
      currency: this.cashOutForm.value.currency,
    };
    this.platformService.withdrawMoney(data).pipe(takeUntil(this.#unsubscribe)).subscribe({
      next: () => {
        this.error = '';
        this.openSuccessDialog();
        this.withdrawSuccess = true;
      },
      error: (err) => {
        this.error = err.error.errors[0].msg;
        this.cashOutForm.patchValue({ money: null });
      },
      complete: () => {
        if (this.withdrawSuccess) {
          this.dialogRef.close(true);
        } else {
          this.dialogRef.close(false);
        }
      },
    });
  }

  openSuccessDialog() {
    const cbu = this.listCbu.find((x: { id: any; }) => {
      return x.id == this.cashOutForm.value.cbu
    })

    this.dialog.open(SuccessChangePasswordDialog, {
      panelClass: ['dialog'],
      width: '500px',
      scrollStrategy: new NoopScrollStrategy(),
      data: {
        title:
          'Realizamos la transferencia por ' +
          ' </br>  ' +
          parseInt(this.cashOutForm.value.money) + ' ' +
          this.cashOutForm.value.currency +
          '</br>  A su cuenta ' +
          cbu.name
      },
    });
  }

  createAccount() {
    if (this.cashOutForm.value.currency) {
      this.router.navigate(['/platform/profile/bankAccount'], {
        queryParams: {
          openAccount: true,
          currency: this.cashOutForm.value.currency,
        },
      });
    } else {
      this.router.navigate(['/platform/profile/bankAccount'], {
        queryParams: { openAccount: true },
      });
    }
  }
}
